"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UNCLASSIFIED_SIGMA_MODEL_ID = void 0;
exports.createDefaultPackageResolution = createDefaultPackageResolution;
exports.UNCLASSIFIED_SIGMA_MODEL_ID = 'ic.generic';
const DEFAULT_PACKAGE_RESOLUTION = Object.freeze({
    sigmaModelId: exports.UNCLASSIFIED_SIGMA_MODEL_ID,
    pins: [],
    sigmaModelParameters: {},
    spiceModels: [],
    subModelEditor: {},
    modes: [],
    boundaries: [],
    resources: [],
    functions: [],
    signals: [],
    signalDifferentialPairs: [],
});
function createDefaultPackageResolution() {
    return structuredClone(DEFAULT_PACKAGE_RESOLUTION);
}
//# sourceMappingURL=package-store-package-resolution.js.map